/**
 * Credit ↔ Wallet economics (defaults). Live values: system/creditEconomy + CreditEconomyContext.
 */

export {
  DEFAULT_CREDIT_ECONOMY,
  APPROVAL_CATEGORY_KEYS,
  normalizeCreditEconomyConfig,
  createCreditEconomyHelpers,
  defaultCreditEconomyHelpers,
} from '../utils/creditEconomyConfig';

import { defaultCreditEconomyHelpers } from '../utils/creditEconomyConfig';

/** @deprecated prefer useCreditEconomy() — defaults until Firestore loads. */
export const CREDIT_TO_WALLET_CENTS = defaultCreditEconomyHelpers.CREDIT_TO_WALLET_CENTS;
export const CREDIT_EARN_CENTS = defaultCreditEconomyHelpers.CREDIT_EARN_CENTS;
export const FUNDS_EARN_CENTS = defaultCreditEconomyHelpers.FUNDS_EARN_CENTS;
export const TEST_ACCESSIBILITY_APPROVAL_CREDIT_UNITS =
  defaultCreditEconomyHelpers.config.approvalCreditUnitsByCategory.accessibility;

export const creditEarnCentsForApproval = defaultCreditEconomyHelpers.creditEarnCentsForApproval;
export const creditEarnUnitsForApproval = defaultCreditEconomyHelpers.creditEarnUnitsForApproval;
export const convertCreditsCentsToWalletCents = defaultCreditEconomyHelpers.convertCreditsCentsToWalletCents;
export const creditsCentsToCreditUnits = defaultCreditEconomyHelpers.creditsCentsToCreditUnits;
export const formatCreditsAmount = defaultCreditEconomyHelpers.formatCreditsAmount;
export const formatCreditToWalletRateLabel = defaultCreditEconomyHelpers.formatCreditToWalletRateLabel;
export const formatCreditExchangeRateLine = defaultCreditEconomyHelpers.formatCreditExchangeRateLine;
